module.exports = __webpack_public_path__ + "img/happy-angel.2d8330ee.svg";